import { gql } from '@apollo/client';

const COMPLETE_SUPPORT_REQUEST_MUTATION = gql`
  mutation completeSupportRequest($id: ID!) {
    completeSupportRequest(id: $id) {
      isSuccess
      message
    }
  }
`;

export default COMPLETE_SUPPORT_REQUEST_MUTATION;
